@if (isViewerRoute) {
  <router-outlet></router-outlet>
} @else {
  <div class="vig-app">
    <ng-container *ngTemplateOutlet="layoutTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="toastTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="overlayTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="spinnerTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="dialogTemplate"></ng-container>
  </div>
}

<ng-template #layoutTemplate>
  <vig-layout>
    <router-outlet></router-outlet>
  </vig-layout>
</ng-template>

<ng-template #toastTemplate>
  <p-toast position="bottom-center" [autoZIndex]="true" />
</ng-template>

<ng-template #overlayTemplate>
  @if (_overlayVisible) {
    <div class="vig-app--blockui"></div>
  }
</ng-template>

<ng-template #spinnerTemplate>
  @if (_spinnerVisible) {
    <div class="vig-app--spinner">
      <div class="vig-spinner"></div>
    </div>
  }
</ng-template>

<ng-template #dialogTemplate>
  <ng-container *ngTemplateOutlet="commonDialogTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="idleInactiveDialogTemplate"></ng-container>
</ng-template>

<ng-template #commonDialogTemplate>
  <p-dialog
    [style]="{ 'min-width': '30rem' }"
    [closable]="false"
    [header]="_dialogTitle ?? ''"
    [modal]="_dialogModal"
    [visible]="_dialogVisible"
  >
    <div [innerHTML]="_dialogMessage"></div>
    <ng-template pTemplate="footer">
      <div class="w-full flex gap-2 justify-content-between">
        <div class="flex gap-2"></div>
        <div class="flex gap-2 justify-end">
          <p-button label="Ok" [size]="'small'" (onClick)="onCloseCommonDialog()" />
        </div>
      </div>
    </ng-template>
  </p-dialog>
</ng-template>

<ng-template #idleInactiveDialogTemplate>
  <p-dialog
    header="Session Idle"
    [(visible)]="idleInactiveDialogVisible"
    [style]="{ 'min-width': '30rem', width: '50rem', height: '15rem' }"
    [modal]="true"
    [closable]="false"
  >
    <div>
      You have been inactive for a period of time, to protect sensitive information your session will automatically logout unless you hit
      the 'Resume' button to continue.
    </div>
    <ng-template pTemplate="footer">
      <div class="w-full flex gap-2 justify-content-between">
        <div class="flex gap-2"></div>
        <div class="flex gap-2 justify-end">
          <p-button
            label="Logout"
            icon="pi pi-sign-out"
            styleClass="p-button-outlined"
            [badge]="idleLoggoutCountdown"
            badgeSeverity="danger"
            (onClick)="idleAcceptInactiveDialog()"
          ></p-button>
          <p-button label="Resume" icon="pi pi-check" class="p-button-text" (onClick)="idleDismissInactiveDialog()"></p-button>
        </div>
      </div>
    </ng-template>
  </p-dialog>
</ng-template>
